import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';

import { LanguageService } from '@uigy/shared/services/language.service';
import { UiRiskScoreTooltipComponent } from '@uigy/shared/components/tooltip/ui-risk-score-tooltip/ui-risk-score-tooltip.component';
import { UiTooltipThemeEnum } from '@uigy/shared/enums/ui-tooltip.enum';
import { RiskScoreService } from '@uigy/shared/components/risk-score/services/risk-score.service';
import { take } from 'rxjs/operators';
import {
  IconNumberTextWidgetComponent
} from '@uigy/shared/components/ui-data-widgets/ui-icon-number-text-widget/icon-number-text-widget.component';
import { IconNumberTextWidgetVariant } from '@uigy/shared/components/ui-data-widgets/ui-icon-number-text-widget/interfaces';
import { RiskModel, RiskService } from '@uigy/shared/services/risk.service';
import { IconsEnum } from '@uigy/generated/icons.enum';


@Component({
    selector: 'app-risk-score-widget',
    imports: [
    IconComponent,
    UiRiskScoreTooltipComponent,
    IconNumberTextWidgetComponent
],
    templateUrl: './risk-score.component.html',
    styleUrl: './risk-score.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RiskScoreComponent implements OnInit {
  private languageService = inject(LanguageService);
  private riskScoreService = inject(RiskScoreService);
  private cdr = inject(ChangeDetectorRef);
  private riskService = inject(RiskService);

  protected readonly IconsEnum = IconsEnum;
  public riskTexts = this.languageService.texts.general.risk.widget;
  public riskScore?: number;
  public title: string = '';
  public numeratorClass: string = '';
  public riskIconVariant: IconNumberTextWidgetVariant = IconNumberTextWidgetVariant.orange;
  public readonly UiTooltipThemeEnum = UiTooltipThemeEnum;

  ngOnInit(): void {
    this.riskScoreService.getRiskScore().pipe(take(1)).subscribe(riskScore => {
      this.riskScore = Math.floor(riskScore);
      const riskModel: RiskModel = this.riskService.getRiskModel(this.riskScore);
      this.riskIconVariant = riskModel.riskWidgetVariant;

      switch (riskModel.category) {
        case 'high':
          this.title = this.riskTexts.high;
          this.numeratorClass = 'high-color';
          break;
        case 'medium':
          this.title = this.riskTexts.medium;
          break;
        default:
          this.title = this.riskTexts.low;
      }
      this.cdr.markForCheck();
    });
  }
}

